import { z } from 'zod';
/**
 * Schema for client-side (browser / Electron renderer) environment variables.
 * All keys must be prefixed with VITE_ so Vite embeds them at build time.
 * Call parseClientEnv(import.meta.env) from the app entrypoint.
 *
 * IMPORTANT: No defaults are provided for URL vars. Vite bakes these in at
 * build time. A missing value must fail loudly here rather than silently
 * falling back to localhost in a production bundle.
 *
 * For local dev, copy apps/web/.env.example → apps/web/.env.local.
 */
export const clientEnvSchema = z.object({
    VITE_SUPABASE_URL: z.string().url(),
    VITE_SUPABASE_ANON_KEY: z.string().min(1),
    VITE_API_URL: z.string().url(),
    VITE_GATEWAY_URL: z.string().url(),
});
/**
 * Parse and validate client environment from an env object.
 * Usage: `export const clientEnv = parseClientEnv(import.meta.env)`
 */
export function parseClientEnv(raw) {
    const result = clientEnvSchema.safeParse(raw);
    if (!result.success) {
        const issues = result.error.issues
            .map((i) => `  ${i.path.join('.')}: ${i.message}`)
            .join('\n');
        throw new Error(`Invalid client environment variables:\n${issues}`);
    }
    return result.data;
}
//# sourceMappingURL=schema.client.js.map